import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { RouterLinkDirective, ViewportDetectionService } from '@hyundai/ng-common-lib';

@Component({
    standalone: true,
    imports: [RouterLinkDirective, NgClass],
    selector: 'lib-pagination',
    templateUrl: './pagination.component.html',
    styleUrl: './pagination.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class PaginationComponent {
    activatedRoute = inject(ActivatedRoute);
    viewport = inject(ViewportDetectionService);

    pageLength = input<number>(12);
    allItemsCount = input.required<number>();

    queryParams = toSignal(this.activatedRoute.queryParams);

    currentPage = computed(() => Number(this.queryParams()?.['page'] ?? 1));
    totalPages = computed(() => {
        if (this.allItemsCount() === 0) return [];
        const arraylength = this.pageLength() === 0 ? 0 : Math.ceil(this.allItemsCount() / this.pageLength());
        return Array.from({ length: arraylength }, (_, i) => i + 1);
    });

    pagesRendered = computed(() => {
        const totalPages = this.totalPages().length;
        const currentPage = this.currentPage();

        if (totalPages <= 1) return;

        const render: Array<string | number> = [];

        render.push(1);

        if (currentPage > 3) render.push('...');

        const start = Math.max(2, currentPage - 1);
        const end = Math.min(totalPages - 1, currentPage + 1);

        for (let i = start; i <= end; i++) {
            render.push(i);
        }

        if (end < totalPages - 1) render.push('...');

        if (totalPages > 1) render.push(totalPages);

        return render;
    });
}
